/* Keep mobile support compact without changing the chat service or its messages. */
(function () {
  function styleChat() {
    var widget = document.querySelector('chat-widget');
    var root = widget && widget.shadowRoot;
    if (!root || root.querySelector('[data-ttc-chat-presentation]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-ttc-chat-presentation', '');
    style.textContent = '@media (max-width:767px) {' +
      '.lc_text-widget--prompt { display:none !important; }' +
      '.lc_text-widget--bubble { width:48px !important; height:48px !important; right:12px !important; bottom:12px !important; }' +
      '}';
    root.appendChild(style);
  }
  window.addEventListener('LC_chatWidgetLoaded', styleChat);
  styleChat();
})();
